import Column from '@app/components/layout/Column'
import useMediaQuery from '@app/util/useMediaQuery'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { pages } from '@app/util/links'
import Row from '@app/components/layout/Row'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import { GeoViewModel } from './models'

export const StepByStep = ({ region: _region }: { region: GeoViewModel }) => {
  const isMobile = useMediaQuery()
  const largerGap = isMobile ? '2rem' : '1.5rem'
  const [language, _] = useLanguage()
  const translations = i18n.languages[language].app
  return (
    <Column gap={largerGap} alignItems="stretch">
      <SectionHeader
        title={translations.regionPage.stepByStep + ' ' + 'Drenthe'}
        seeMore={translations.common.seeMore}
        toRoute={pages.knowledgeHub}
      />
      <Row style={{ gap: '1rem' }}>
        <Column>
          <BlogCard
            image="https://images.pexels.com/photos/2917838/pexels-photo-2917838.jpeg"
            meta="Introductie"
            title="Hoe helpt de gemeente Amsterdam wooncoöperaties?"
            to="/non-existing-route"
          />
        </Column>
        <Column>
          <BlogCard
            image="https://images.pexels.com/photos/2917838/pexels-photo-2917838.jpeg"
            meta="Introductie"
            title="Hoe helpt de gemeente Amsterdam wooncoöperaties?"
            orientation="horizontal"
            to="/non-existing-route"
          />
          <BlogCard
            image="https://images.pexels.com/photos/2917838/pexels-photo-2917838.jpeg"
            meta="Introductie"
            title="Hoe helpt de gemeente Amsterdam wooncoöperaties?"
            orientation="horizontal"
            to="/non-existing-route"
          />
        </Column>
      </Row>
    </Column>
  )
}
